import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const usage = apiUrl + "/usage";
const routes = {
  label: "Usage",
  root: usage,
  get_mine: usage + "/get_mine",
  get_mine_company: usage + "/get_mine_company",
  get_all_company: usage + "/get_all_company",
};

export const Usage = {
  label: routes.label,
  get_mine: () => postWithToken(routes.get_mine),
  getMineCompany: () => postWithToken(routes.get_mine_company),
  getAllCompany: () => postWithToken(routes.get_all_company),
};
